"use strict";

module.exports = require("./Audio.js");